import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7779b40c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = { class: "pb-3 d-flex justify-content-between" }
const _hoisted_4 = { class: "fw-bold d-flex align-items-center text-dark ms-3 mt-3 mt-lg-0" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_6 = { class: "py-3 d-flex justify-content-between" }
const _hoisted_7 = { class: "fw-bold d-flex align-items-center text-dark ms-3 mt-3 mt-lg-0" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "py-3" }
const _hoisted_12 = { class: "fw-bold d-flex align-items-center text-dark ms-3 mt-3 mt-lg-0" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))

import { inject } from "vue";
import { occupations } from "@/core/types/jp/verificationInfo";
import {
  accountTypesSelection,
  accountRolesSelection,
  investorDistinctionSelection,
  moneyRange,
  mainIncomeSources,
  transactionMotives,
  mainFunds,
  experienceSelections,
  investmentPurposes,
  assetManagementPeriodSelection,
  financialInstiutionTypes,
  depositTypesSelection,
} from "@/core/types/jp/verificationFinancial";
import { getDataByCode } from "@/core/data/phonesData";
import { isMobile } from "@/core/config/WindowConfig";

export default /*#__PURE__*/_defineComponent({
  __name: 'ProductReview',
  setup(__props) {

const items = inject<any>("items");
const currentStepIndex = inject<any>("currentStepIndex");
const isSubmitting = inject<any>("isSubmitting");
const colSize = isMobile.value ? 1 : 2;
function getLabelByValue(value, array) {
  const data = array.find((data) => data.value === value);
  return data ? data.label : null;
}

function searchByValue(value, range) {
  for (const key in range) {
    if (range[key].value === value) {
      return range[key].label;
    }
  }
  return null;
}

function getDataByCodeUpdate(code, answer) {
  var res = getDataByCode(code);
  res = res.name ?? null;
  if (!res) {
    return answer;
  }

  return res;
}

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")!
  const _component_el_descriptions = _resolveComponent("el-descriptions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.$t("title.personalInfo")), 1),
        _createVNode(_component_el_button, {
          type: "primary",
          size: "large",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (currentStepIndex.value = 1)),
          disabled: _unref(isSubmitting)
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.edit")), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _hoisted_5,
      _createVNode(_component_el_descriptions, {
        column: _unref(colSize),
        size: "large",
        border: "",
        class: "pb-3"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.firstName')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).data?.info?.firstName), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.lastName')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).data?.info?.lastName), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.nativeNameLast')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).data?.info?.nativeNameLast), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.nativeNameFirst')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).data?.info?.nativeNameFirst), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.gender'),
            span: "2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).data?.info?.gender == "0"
            ? _ctx.$t("fields.male")
            : _ctx.$t("fields.female")), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.birthdate')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).data?.info?.birthday), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.age')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).data?.info?.age), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.postalCode')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).data?.info?.postalCode), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.region')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).data?.info?.region), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.village')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).data?.info?.village), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.town')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).data?.info?.town), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.street')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).data?.info?.street), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.buildingNumber')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).data?.info?.buildingNumber), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.email')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).data?.info?.email), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.phone')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).data?.info?.phone), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.occupation')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(getLabelByValue(_unref(items).data?.info?.occupation, _unref(occupations))), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.companyName')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).data?.info?.companyName), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.affiliatedDepartment')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).data?.info?.affiliatedDepartment), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.affiliatedPosition')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).data?.info?.affiliatedPosition), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.companyPhone')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).data?.info?.companyPhone), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.nationalityInformation')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(getDataByCodeUpdate(
            _unref(items).data?.info?.citizen,
            _unref(items).data?.info?.otherCitizen
          )), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.countryOfResidence')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(getDataByCodeUpdate(
            _unref(items).data?.info?.countryOfResidence,
            _ctx.$t("fields.residenceThanJapan")
          )), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.usTaxLiability')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).data?.info?.usTax == true ? _ctx.$t("action.yes") : _ctx.$t("action.no")), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.declarationRegardingForeignPeps'),
            span: "2"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(items).data?.info?.declarationRegardingForeignPeps == "no"
              ? _ctx.$t("action.no")
              : _unref(items).data?.info?.otherPeps), 1)
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["column"]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("h2", _hoisted_7, _toDisplayString(_ctx.$t("title.financial")), 1),
        _createVNode(_component_el_button, {
          type: "primary",
          size: "large",
          disabled: _unref(isSubmitting),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (currentStepIndex.value = 2))
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t("action.edit")), 1)
          ]),
          _: 1
        }, 8, ["disabled"])
      ]),
      _hoisted_8,
      _createVNode(_component_el_descriptions, {
        column: _unref(colSize),
        border: "",
        class: "pb-lg-3",
        size: "large"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.accountType'),
            span: 2
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(getLabelByValue(
            _unref(items).data?.financial?.accountRole,
            _unref(accountRolesSelection)
          )), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.preferredTradingAccount'),
            span: 2
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items).data?.financial?.accountTypes, (item) => {
                return (_openBlock(), _createElementBlock("div", { key: item }, _toDisplayString(getLabelByValue(item, _unref(accountTypesSelection))), 1))
              }), 128))
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.investorDistinction'),
            span: 2
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items).data?.financial?.investorDistinction, (item) => {
                return (_openBlock(), _createElementBlock("div", { key: item }, _toDisplayString(getLabelByValue(item, _unref(investorDistinctionSelection))), 1))
              }), 128))
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.mainSourceOfIncome')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(getLabelByValue(
            _unref(items).data?.financial?.mainIncomeSource,
            _unref(mainIncomeSources)
          )), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.annualIncome')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(searchByValue(_unref(items).data?.financial?.annualIncome, _unref(moneyRange))), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.valueOfInvestment')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(searchByValue(_unref(items).data?.financial?.investment, _unref(moneyRange))), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.amountOfInvestmentFunds')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(searchByValue(_unref(items).data?.financial?.investmentFunds, _unref(moneyRange))), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.mainSourceOfIncome')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(getLabelByValue(
            _unref(items).data?.financial?.mainIncomeSource,
            _unref(mainIncomeSources)
          )), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.transactionMotive')
          }, {
            default: _withCtx(() => [
              (!_unref(items).data?.financial?.transactionMotiveOther)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(getLabelByValue(
                _unref(items).data?.financial?.transactionMotive,
                _unref(transactionMotives)
              )), 1))
                : (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString((_unref(items).data?.financial?.transactionMotive, _unref(transactionMotives))), 1))
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.characteristicsOfMainFunds')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(getLabelByValue(_unref(items).data?.financial?.mainFund, _unref(mainFunds))), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.assetManagementPeriod')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(getLabelByValue(
            _unref(items).data?.financial?.assetManagementPeriod,
            _unref(assetManagementPeriodSelection)
          )), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: 'FX' + ' (' + _ctx.$t('fields.foreignExchangeMarginTrading') + ')'
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(getLabelByValue(_unref(items).data?.financial?.fx, _unref(experienceSelections))), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.stockTradingSpot')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(getLabelByValue(
            _unref(items).data?.financial?.stockTradingSpot,
            _unref(experienceSelections)
          )), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.stockTradingCredit')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(getLabelByValue(
            _unref(items).data?.financial?.stockTradingCredit,
            _unref(experienceSelections)
          )), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.indexOption')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(getLabelByValue(
            _unref(items).data?.financial?.indexOption,
            _unref(experienceSelections)
          )), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.commodityFuturesTrading')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(getLabelByValue(
            _unref(items).data?.financial?.commodityFuturesTrading,
            _unref(experienceSelections)
          )), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.otherDerivativesTransaction')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(getLabelByValue(
              _unref(items).data?.financial?.otherDerivativesTransaction,
              _unref(experienceSelections)
            )), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.investmentPurposeOfFxTrading')
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(items).data?.financial?.investmentPurpose, (item) => {
                return (_openBlock(), _createElementBlock("div", { key: item }, _toDisplayString(getLabelByValue(item, _unref(investmentPurposes))), 1))
              }), 128))
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["column"]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("h2", _hoisted_12, _toDisplayString(_ctx.$t("title.marginReturnAccount")), 1)
      ]),
      _hoisted_13,
      _createVNode(_component_el_descriptions, {
        column: _unref(colSize),
        border: "",
        class: "pb-lg-3",
        size: "large"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.financialInstiutionName')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_unref(items).data?.financial?.financialInstiutionName), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.financialInstiutionType')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(getLabelByValue(
                _unref(items).data?.financial?.financialInstiutionType,
                _unref(financialInstiutionTypes)
              )), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.financialInstitutionCode')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_unref(items).data?.financial?.financialInstitutionCode), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.branchName')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_unref(items).data?.financial?.branchName), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.branchCode')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_unref(items).data?.financial?.branchCode), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.depositType')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(getLabelByValue(
                _unref(items).data?.financial?.depositType,
                _unref(depositTypesSelection)
              )), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.accountHolderFullWidth')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_unref(items).data?.financial?.accountHolderFullWidth), 1)
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_el_descriptions_item, {
            label: _ctx.$t('fields.accountHolderFullWidthKatakana')
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", null, _toDisplayString(_unref(items).data?.financial?.accountHolderFullWidthKatakana), 1)
            ]),
            _: 1
          }, 8, ["label"])
        ]),
        _: 1
      }, 8, ["column"])
    ])
  ]))
}
}

})